import type { OrganisationResponseRow } from '@risksmart-app/drizzle/src/types';
import type {
  GetOrganisationQuery,
  GetOrganisationQueryVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOrganisationDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createQueryHook } from '../utils/hook-factories';

const useGetOrganisation = createQueryHook<
  Record<string, never>,
  OrganisationResponseRow[],
  GetOrganisationQuery,
  GetOrganisationQueryVariables
>({
  trpcQueryOptions: (trpc) => trpc.frontend.organisation.current.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ auth_organisation: data }),
  graphqlDocument: GetOrganisationDocument,
});

/**
 * Fetches the current organisation through the same transport-switching seam
 * as web. `cache-first` preserves Apollo's historical bootstrap behaviour.
 */
export const useGetOrganisationForFeatureBootstrap = () =>
  useGetOrganisation({ queryArgs: {}, fetchPolicy: 'cache-first' });
